import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const InfoPopUp = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button size="small" class="info-button" variant="outlined" onClick={handleClickOpen}>
        ?
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Über diese Nebelkarte
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom class="info_content">
            Diese Nebelkarte der Schweiz zeigt die Hochnebel-Obergrenze als interaktive Karte an.
          </Typography>
          <Typography gutterBottom class="info_content">
            Die Prognose ist wählbar für heute, morgen und übermorgen, jeweils je für die vier
            Regionen der Schweiz: Alpen-Voralpen, Westschweiz, Ostschweiz und Tessin.
            Weitere mögliche regionale Unterschiede können nicht berücksichtigt werden.
          </Typography>
          <Typography gutterBottom class="info_content">
            Die Prognose wird um ca. 6 Uhr Morgens ausgegeben. Neben der mittleren Höhe
            kann in Klammern auch ein Höhenbereich angegeben sein.
          </Typography>
          <Typography gutterBottom class="info_content">
            Die Karte macht sichtbar, welche Gebiete hochnebelfrei sind. Sie gibt Orientierung für die Tagesplanung
            und zeigt, wann wieder mit Sonne zu rechnen ist. Die Karte ist vor allem zur Freizeitplanung gedacht.
            Sie hilft bei Spaziergängen, Ausflügen und Wanderungen. Fotografierende nutzen sie, um Lichtstimmungen einzufangen.
            Auch Hundehalter:innen greifen darauf zurück.
          </Typography>
          <Typography gutterBottom class="info_content">
            Von Anfang Oktober bis Anfang März gibt es im Schweizer Mittelland oft Hochnebel, dessen Obergrenze schwer
            vorhersagbar ist. Die Einzigartigkeit der Nebelkarte beruht neben der raffinierten kartografischen
            Visualisierung darauf, dass die Nebelprognose viel meteorologische Erfahrung erfordert und immer
            noch mit grossen Unsicherheiten verbunden ist. Dies reduziert die Prognosesicherheit, was wohl die Wetterdienste
            vermeiden wollen. <br/>Bodennebel wird auf dieser Karte nicht angezeigt.
          </Typography>
          <Typography gutterBottom class="info_content">
            Der &quot;Was wäre wenn?&quot;-Knopf in der Benutzeroberfläche bietet einen Schieberegler,
            mit dem Sie potenzielle Hochnebel-Obergrenzen simulieren können.
          </Typography>
          <Typography gutterBottom class="info_content">
            Diese Webanwendung wurde vom IFS Institut für Software am OST Campus Rapperswil entwickelt. Sie wird bis auf weiteres
            und ohne Gewähr frei zur Verfügung gestellt. Die Nutzung erfolgt auf eigenes Risiko.
          </Typography>
        </DialogContent>
        <DialogContent dividers sx={{ 'overflow-y' : 'visible' }}>
          <Typography gutterBottom class="info_content">
            Falls Sie Fragen, Anregungen oder Feedback haben, kontaktieren Sie uns gerne:<br />
            <div className="contact_button">
              <Button sx={{ 'margin-top': '10px', 'background-color': '#8c195f'}} variant="contained" href="mailto:stefan.keller@ost.ch?subject=Feedback%20Nebelkarte">Kontakt</Button>
            </div>
          </Typography>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}

export default InfoPopUp
